<template lang="pug">

    div

        product-summary(
            :product-model='productModel'
            :media-production-person-model='mediaProductionPersonModel'
            :product-type-model='productTypeModel'
        )

        //- Content
        .ui.segment

            navigation(v-bind:offer-model='offerModels[0]' v-bind:job-model="jobModel")

            .ui.basic.cards

                shipping-address-card(
                    v-for='shippingAddressModel in shippingAddressModels'
                    v-bind:key='shippingAddressModel.id'
                    v-bind:address-models='addressModels'
                    v-bind:company-model='companyModel'
                    v-bind:is-editable='false'
                    v-bind:is-deletable='false'
                    v-bind:is-private='isPrivate'
                    v-bind:person-models='[]'
                    v-bind:shipping-address-model='shippingAddressModel'
                )

            .ui.divider(v-if='specimenCopyModel || specimenCopyInternalModel')

            .ui.basic.cards

                specimen-copy-address-card(
                    v-if='specimenCopyModel'
                    v-bind:address-models='addressModels'
                    v-bind:company-model='companyModel'
                    v-bind:is-editable='false'
                    v-bind:is-internal='false'
                    v-bind:is-private='isPrivate'
                    v-bind:product-model='productModel'
                    v-bind:show-address-name='false'
                    v-bind:specimen-copy-model='specimenCopyModel'
                )

                specimen-copy-address-card(
                    v-if='specimenCopyInternalModel'
                    v-bind:address-models='addressModels'
                    v-bind:company-model='companyModel'
                    v-bind:is-editable='false'
                    v-bind:is-internal='true'
                    v-bind:is-private='isPrivate'
                    v-bind:product-model='productModel'
                    v-bind:show-address-name='false'
                    v-bind:specimen-copy-model='specimenCopyInternalModel'
                )

</template>

<script>
    import store from '@/store'
    import Navigation from '@/components/offers/Navigation'
    import ProductSummary from '@/components/offers/Summary'
    import ShippingAddressCard from '@/components/addresses/ShippingAddressCard'
    import SpecimenCopyAddressCard from '@/components/addresses/SpecimenCopyAddressCard'
    import * as R from "ramda";

    //noinspection JSUnusedLocalSymbols,JSUnusedGlobalSymbols
    export default {

        async beforeRouteEnter(to, from, next) {
            // Job laden
            const jobModel = await store.dispatch('jobs/loadOne', { id: to.params.jobId })

            const [ productModel ] = await Promise.all([

                // Produkt laden
                store.dispatch('products/loadOne', { id: jobModel.product }),

                // Angebote laden
                store.dispatch('offers/loadAllByJobId', { jobId: jobModel.id }),

                // Lieferadressen laden
                store.dispatch('shippingAddresses/loadAllByProductId', { productId: jobModel.product }),

                // Adressen laden
                store.dispatch('addresses/loadAllByJobId', { jobId: jobModel.id }),

                // Unternehmen laden
                store.dispatch('companies/loadAllByJobId', { jobId: jobModel.id }),

            ])

            // Lädt Belegexemplar
            const loadSpecimenCopy = id => R.ifElse(
                R.isNil, () => Promise.resolve({}), id => store.dispatch('specimenCopies/loadOne', { id })
            )(id)

            // Belegexemplare, Produkttyp und Medienproduktioner laden
            const [ specimenCopy, specimenCopyInternal ] = await Promise.all([
                loadSpecimenCopy(productModel.specimenCopy),
                loadSpecimenCopy(productModel.specimenCopyInternal),
                store.dispatch('productTypes/loadOne', { id: productModel.type }),
                store.dispatch('persons/loadOneByUserId', { userId: productModel.mediaProduction })
            ])

            // Empfänger-Personen der Belegexemplare laden (für die Anzeige)
            await Promise.all(
                [specimenCopy, specimenCopyInternal]
                    .filter(copy => copy && R.is(Number, copy.recipient))
                    .map(copy => store.dispatch('persons/loadOne', { id: copy.recipient }))
            )

            next()
        },

        components: { ShippingAddressCard, SpecimenCopyAddressCard, Navigation, ProductSummary },

        computed: {

            addressModels() {
                return store.getters['addresses/all']
            },

            companyModel() {
                return store.getters['companies/byId'](this.productModel.company)
            },

            isPrivate() {
                return this.jobModel.status !== "ACCEPTED"
            },

            jobModel() {
                return store.getters['jobs/byId'](this.$route.params.jobId)
            },

            mediaProductionPersonModel() {
                return store.getters['persons/byUserId'](this.productModel.mediaProduction)
            },

            productTypeModel() {
                return store.getters['productTypes/byId'](this.productModel.type)
            },


            offerModels() {
                return store.getters['offers/allByJobId'](this.jobModel.id)
            },

            productModel() {
                return store.getters['products/byId'](this.jobModel.product)
            },

            specimenCopyModel() {
                return store.getters['specimenCopies/byId'](this.productModel.specimenCopy)
            },

            specimenCopyInternalModel() {
                return store.getters['specimenCopies/byId'](this.productModel.specimenCopyInternal)
            },

            specimenCopyAddressModel() {
                return this.getSpecimenCopyAddressModel(this.specimenCopyModel)
            },

            specimenCopyInternalAddressModel() {
                return this.getSpecimenCopyAddressModel(this.specimenCopyInternalModel)
            },

            shippingAddressModels() {
                return store.getters['shippingAddresses/allByProductId'](this.jobModel.product)
            }

        },

        methods: {

            getSpecimenCopyAddressModel(specimenCopyModel) {
                return R.compose(

                    // Adressen anhand von ID holen
                    store.getters['addresses/byId'],

                    // Adressen-ID auslesen
                    R.prop('address'),

                    // ggf. leere Model setzen
                    R.defaultTo({})

                )(specimenCopyModel)
            }

        }

    }

</script>
